export function inClientCare(pathname: string): boolean {
  return pathname.startsWith('/care/');
}

export function therapistListPath(pathname: string): string {
  return inClientCare(pathname) ? '/care/find' : '/therapists';
}

export function therapistProfilePath(pathname: string, id: string): string {
  return `${therapistListPath(pathname)}/${id}`;
}

export function resourceListPath(pathname: string): string {
  return inClientCare(pathname) ? '/care/resources' : '/learn';
}

export function resourceArticlePath(pathname: string, slug: string): string {
  return `${resourceListPath(pathname)}/${slug}`;
}
